import { environment } from '@lib/environment';
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, Method } from 'axios';

export class HttpRequest {
    readonly TIMOUT_SECONDS: number = 10;
    private axiosInstance: AxiosInstance;

    constructor() {
        this.axiosInstance = axios.create({
            timeout: this.TIMOUT_SECONDS * 1000,
        });
    }

    public get(url: string, config: AxiosRequestConfig = {}) {
        return this.send('get', url, undefined, config);
    }

    public post(url: string, data: any, config: AxiosRequestConfig = {}) {
        return this.send('post', url, data, config);
    }

    public put(url: string, data: any, config: AxiosRequestConfig = {}) {
        return this.send('put', url, data, config);
    }

    public patch(url: string, data: any, config: AxiosRequestConfig = {}) {
        return this.send('patch', url, data, config);
    }

    public delete(url: string, config: AxiosRequestConfig = {}) {
        return this.send('delete', url, undefined, config);
    }

    private async send(
        method: Method,
        url: string,
        body: any,
        config: AxiosRequestConfig,
    ): Promise<AxiosResponse> {
        try {
            config.baseURL = environment.REACT_APP_API_URL();
            config.method = method;
            config.url = url;
            config.data = body;

            const token = await localStorage.getItem('accessToken');
            const defaultHeaders = {
                authorization: `Bearer ${token}`,
            };
            config.headers = Object.assign(defaultHeaders, config.headers);

            return await this.axiosInstance.request(config);
        } catch (err) {
            if (axios.isAxiosError(err)) {
                // return all responses, even if status not 2xx
                if (err.response) return err.response;
            }
            throw err;
        }
    }

    public isSuccessful(res: AxiosResponse, customSuccess?: number[]): boolean {
        if (200 <= res.status && res.status < 300) return true;
        return customSuccess?.includes(res.status) ?? false;
    }
}
